import React from 'react';
import { Search } from 'carbon-components-react';
import { useSelector } from 'react-redux';
import { selectedMembers, selectMemberLoading } from 'redux/members';
import { FormError } from 'components';

interface Props {
  setSearchInputValue: Function;
  searchInputValue: string;
  getSearchOrganisations: Function;
  clearOrganisations: Function;
  setIsPreviewMode: Function;
}

const SearchOrganisations: React.FC<Props> = ({
  setSearchInputValue,
  searchInputValue,
  getSearchOrganisations,
  clearOrganisations,
  setIsPreviewMode
}) => {
  const organisations: Array<any> = useSelector(selectedMembers);
  const isLoadingOrganisations: boolean = useSelector(selectMemberLoading);

  const handleOnChangeSearchText = (val: string) => {
    if (val) {
      setSearchInputValue(val);
      getSearchOrganisations(val);
      setIsPreviewMode(false);
    } else {
      setSearchInputValue('');
    }
    clearOrganisations();
  };

  return (
    <div className={'announcement-organisation-search-container'}>
      <div className="search-textbox-container">
        <Search
          id="jobIdSearch"
          labelText=""
          value={searchInputValue}
          onChange={(e) => handleOnChangeSearchText(e.target.value)}
          placeHolderText={'Narrow your search ...'}
        />
        {organisations?.length <= 0 && !isLoadingOrganisations && (
          <FormError>{`No result found`}</FormError>
        )}
      </div>
    </div>
  );
};

SearchOrganisations.displayName = 'SearchOrganisations';
export default SearchOrganisations;
